<template>
  <div id="junior-phase">
    <div v-if="hasData(juniorpage)" class="content">
      <h2>{{juniorpage.data.attributes.title}}</h2>
      <About :message="juniorpage.data.attributes.about" />
      <div class="info">
        <InfoCard v-for="(info, key) in juniorpage.data.attributes.information" :key="key" :info="info.info" />
      </div>
      <h3 class="hours-heading">School Hours</h3>
      <div class="hours">
        <TimeCard v-for="(grade, key) in juniorpage.data.attributes.hours" :key="key" :title="grade.title" :times="grade.times" />
      </div>
      <Staff title="Meet our staff" :staff="juniorpage.data.attributes.staff" />
      <Downloads :downloads="juniorpage.data.attributes.downloads" />
    </div>
  </div>
</template>

<script>
import About from '@/components/About'
import InfoCard from '@/components/InfoCard'
import Staff from '@/components/Staff'
import TimeCard from '@/components/TimeCard'
import Downloads from '@/components/Downloads'
import { juniorpage } from '../queries'

export default {
  name: 'JuniorPhase',
  apollo: { juniorpage },
  components: {
    About,
    Staff,
    TimeCard,
    Downloads,
    InfoCard
  },
  methods: {
    hasData (data) {
      if (data) {
        this.$store.dispatch('showLoader', false)
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
#junior-phase .content {
  margin-top: 20px; }
  #junior-phase .content h2 {
    color: white;
    padding: 10px;
    background: #009645; }
  #junior-phase .content .info {
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    opacity: 0.9;
    background: linear-gradient(#6B3EB8, #330D73);
    padding: 10px; }
  #junior-phase .content .hours-heading {
    padding: 5px;
    color: white;
    background: #009645; }
  #junior-phase .content .hours {
    display: flex;
    justify-content: center;
    flex-flow: wrap; }
</style>
